var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZamok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.125V4C9.75 2.34315 8.40685 1 6.75 1H6.25C4.59315 1 3.25 2.34315 3.25 4V9.125",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.41667C0.895431 6.41667 0 7.3121 0 8.41667V14.7083C0 15.8129 0.89543 16.7083 2 16.7083H11C12.1046 16.7083 13 15.8129 13 14.7083V8.41667C13 7.3121 12.1046 6.41667 11 6.41667H2ZM5.875 8.84723C5.32272 8.84723 4.875 9.29494 4.875 9.84723V10.5625V11.4628C4.875 11.9129 5.23986 12.2778 5.68994 12.2778V13.6806C5.68994 14.1331 6.05681 14.5 6.50938 14.5C6.96194 14.5 7.32881 14.1331 7.32881 13.6806V12.2778C7.76853 12.2778 8.125 11.9213 8.125 11.4816V9.84723C8.125 9.29494 7.67728 8.84723 7.125 8.84723H5.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZamok);
export default __webpack_public_path__ + "static/media/zamok.69c7704c75b08f3b8719de38ebbf87e3.svg";
export { ForwardRef as ReactComponent };